// material-ui
import { useTheme } from '@mui/material/styles';

// ==============================|| LOGO ICON SVG ||============================== //

export default function LogoIcon() {
  const theme = useTheme();

  return (

<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="50" height="50" viewBox="0 0 2206.000000 732.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(1.000000,1000.000000) scale(0.600000,-0.500000)"
fill="#1316c9" stroke="none">
<path d="M1500 3240 c-421 -31 -822 -231 -1098 -549 -532 -615 -528 -1532 8
-2140 243 -275 552 -450 922 -522 170 -34 426 -32 599 4 268 56 480 153 684
312 756 592 835 1711 171 2403 -335 349 -799 527 -1286 492z m-594 -448 c41
-21 70 -48 100 -97 18 -28 19 -67 24 -800 5 -760 5 -771 26 -816 85 -184 306
-235 452 -104 78 70 94 118 102 305 6 173 13 193 78 252 51 46 99 61 177 56
106 -7 182 -75 206 -188 17 -79 5 -304 -21 -405 -80 -311 -353 -539 -671 -561
-321 -22 -599 139 -740 430 -75 155 -74 137 -74 996 0 834 -2 809 58 876 71
81 189 104 283 56z m1126 3 c93 -24 216 -88 294 -154 116 -98 192 -213 242
-370 l27 -86 0 -790 0 -790 -22 -41 c-99 -185 -347 -174 -428 19 -13 31 -15
134 -15 769 0 834 2 810 -77 898 -62 69 -119 95 -213 94 -57 0 -85 -5 -116
-22 -61 -31 -101 -68 -131 -120 -26 -43 -28 -56 -33 -207 -5 -139 -9 -167 -29
-208 -40 -83 -114 -128 -207 -128 -66 0 -88 6 -141 42 -28 19 -50 47 -68 84
-27 54 -27 55 -23 242 4 179 6 192 35 276 17 48 46 113 64 144 46 78 190 222
266 266 75 43 188 85 263 97 75 12 235 4 312 -15z m-594 -1201 c56 -33 98 -92
113 -159 10 -46 9 -61 -6 -106 -23 -73 -48 -105 -108 -139 -119 -68 -271 -19
-328 105 -57 125 21 293 152 325 52 13 129 2 177 -26z"/>
</g>
</svg>
  );
}
